import { createLayeredConstructionApi } from "features/shared/layered-construction-config/api/createLayeredConstructionApi";
import { LayeredConstructionTab } from "features/shared/layered-construction-config/components/LayeredConstructionTab";
import { buildVariant } from "features/shared/layered-construction-config/model/variants";

const FLOOR_VARIANT = buildVariant({
  cacheRoot: "floorConfigTab",
  catalogSegment: "floor-type-db",
  catalogTypeNameKey: "floorTypeName",
  countLabelKey: "floors",
  groupSegment: "floor-user-defined-types",
  i18nKey: "floor",
  typeDbIdKey: "floorTypeDbId",
  typeDbOverrideKey: "floorTypeDb",
});

export const FloorTab = ({ projectId }: { projectId: string }) => (
  <LayeredConstructionTab
    api={createLayeredConstructionApi(FLOOR_VARIANT)}
    projectId={projectId}
    variant={FLOOR_VARIANT}
  />
);
